import React from "react";
import styled, { css } from "styled-components";

const HideLabel = styled.label<{visible: boolean, type: string}>`
  left: 0 !important;
  text-indent: 2px !important;
  ${props => props.visible && css`opacity: 1 !important; top: 10px !important;`}
  
  ${props => (props.type === 'checkbox' || props.type === 'radio') && `
    opacity: 1 !important;
    position: relative !important;
    top: auto !important;
    display: inline !important;
    font-size: 1rem !important;
    font-weight: 400 !important;

    body.theme-platinum & { text-transform: none !important; }
  `}

  ${props => ('color' in props) && `color: ${props.color} !important;`}
`;

interface Props {
    id: string,
    label: string,
    labelColor?: string,
    required?: boolean
    type: string,
    visible?: boolean,
}

function FieldLabel(props:Props) {
    return <HideLabel
        htmlFor={props.id}
        visible={props.visible === true}
        type={props.type}
        color={props.labelColor || ''}
    >
        {props.label}
        {props.required && <span className="text-primary">*</span>}
    </HideLabel>;
}

export default FieldLabel;